


// Login.jsx
import React, { useState } from 'react';
import { Input, Button, Form } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../components/Axios';
import './Login.css';

function Login() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      // First request: Login
      const loginResponse = await axios.post('/auth/login', values);
      
      if (loginResponse.data) {
        const token = loginResponse.data.token;

        // Second request: Get user details
        const userResponse = await axios.get('/auth/', {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });

        if (userResponse.data) {
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(userResponse.data));
          
          toast.success('🎉 Login successful! Redirecting...', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
          });
          localStorage.setItem('showRefreshHint', 'true');

          setTimeout(() => navigate('/'), 2000);
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Login failed. Please try again.';
      toast.error(`😕 ${errorMessage}`, {
        position: "top-right",
        autoClose: 5000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-left">
          <div className="left-content">
            <h2>Welcome Back</h2>
            {/* <div className="features-list">
              <div className="feature-item">
                <div className="feature-icon">📁</div>
                <div className="feature-text">
                  <h4>Prompt Library</h4>
                  <p>4 proven answer frameworks built in</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎯</div>
                <div className="feature-text">
                  <h4>Angle Manager</h4>
                  <p>Set once, stays on-message every answer</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <div className="feature-text">
                  <h4>One-Click Publishing</h4>
                  <p>Publish directly to Quora via Chrome Extension</p>
                </div>
              </div>
            </div> */}
            <div className="features-list">
  <div className="feature-item">
    <div className="feature-icon">📂</div>
    <div className="feature-text">
      <h4>Answers Built To Convert</h4>
      <p>4 proven answer frameworks built in — pick one and the AI structures the whole answer for you.</p>
    </div>
  </div>
  <div className="feature-item">
    <div className="feature-icon">🎯</div>
    <div className="feature-text">
      <h4>On-Message, Every Time</h4>
      <p>Set your angle, keywords & CTA once — every answer stays locked to what you're promoting.</p>
    </div>
  </div>
  <div className="feature-item">
    <div className="feature-icon">🌐</div>
    <div className="feature-text">
      <h4>Publish Without Leaving</h4>
      <p>Post straight to Quora via the Chrome extension — no tab-switching, no copy-paste.</p>
    </div>
  </div>
</div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-box">
            <div className="login-header">
              <h1>Log In to Your Account</h1>
            </div>

            <Form
              form={form}
              name="login"
              onFinish={handleSubmit}
              layout="vertical"
              className="login-form"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input
                  size="large"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Email address"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: 'Please input your password!' }
                ]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Password"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  loading={loading}
                  className="submit-button"
                >
                  {loading ? 'Logging in...' : 'Log In'}
                </Button>
              </Form.Item>
            </Form>

            {/* <div className="register-link">
              Don't have an account?{' '}
              <span onClick={() => navigate('/register')}>Create account</span>
            </div> */}


            <div className="register-link">
  Don't have an account?{' '}
  <span onClick={() => navigate('/register')}>Create account</span>
  {' '}|{' '}
  <span onClick={() => navigate('/reset-password')}>Forgot password?</span>
</div>

          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default Login;